import { ICampaignSummary } from "@/@types/gamification-report";
import { formatToBRL } from "@/utils/formatToMoney";

export const formatPercent = (rate: number): string =>
  `${((rate ?? 0) * 100).toFixed(1)}%`;

export const summaryRows = (
  summary: ICampaignSummary,
): Array<{ label: string; value: string }> => [
  { label: "Giros totais", value: String(summary.totalSpins) },
  { label: "Vouchers emitidos", value: String(summary.vouchersIssued) },
  { label: "Participantes únicos", value: String(summary.uniqueParticipants) },
  { label: "Vouchers resgatados", value: String(summary.vouchersRedeemed) },
  { label: "Taxa de resgate", value: formatPercent(summary.redemptionRate) },
  {
    label: "Valor total distribuído",
    value: formatToBRL(summary.totalValueDistributed),
  },
];

const escapeCsv = (field: string): string =>
  /[";,\n]/.test(field) ? `"${field.replace(/"/g, '""')}"` : field;

export const buildSummaryCsv = (
  summary: ICampaignSummary,
  campaignName: string,
): string => {
  const lines = [
    `Campanha;${escapeCsv(campaignName)}`,
    "Métrica;Valor",
    ...summaryRows(summary).map(
      (row) => `${escapeCsv(row.label)};${escapeCsv(row.value)}`,
    ),
  ];
  return lines.join("\n");
};

export const downloadCsv = (filename: string, content: string): void => {
  const blob = new Blob([String.fromCharCode(0xfeff) + content], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
